import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const tomos = [{
  id: 'T1',
  title: 'La Mentalidad del DT',
  subtitle: 'La base que nadie te enseña',
  content: 'Construí tu identidad como entrenador antes de que el contexto te la defina. Aprendé a dirigir con autoridad sin gritar, a bancarte la presión de padres y dirigentes, y a llegar a cada práctica con la cabeza donde tiene que estar.',
  bullets: ['Rol, identidad y autoridad del DT', 'Síndrome del impostor en la cancha', 'Cómo ganarte el respeto del plantel']
}, {
  id: 'T2',
  title: 'Plan de Temporada',
  subtitle: 'De la primera práctica al partido final',
  content: 'Estructurá todo tu año competitivo. Sabé exactamente qué trabajar en pretemporada, durante el torneo y en la recta final para llegar al pico de rendimiento cuando más importa.',
  bullets: []
}, {
  id: 'T3',
  title: 'La Sesión Perfecta',
  subtitle: 'Cada entrenamiento con propósito',
  content: 'El método paso a paso para armar prácticas dinámicas de 60 o 90 minutos. Optimizá el tiempo, mantené a todos en movimiento y asegurate de que lo entrenado se vea el fin de semana.',
  bullets: []
}, {
  id: 'T4',
  title: 'Táctica y Sistemas de Juego',
  subtitle: 'Los sistemas que ganan en el amateur',
  content: 'Explicación simple y directa de los sistemas 1-2-2, 1-3-1 y 4-0. Cuándo usar cada uno, cómo enseñarlos sin marear a los jugadores y tácticas de pelota parada que aseguran goles.',
  bullets: []
}, {
  id: 'T5',
  title: 'Evaluá a Tus Jugadores',
  subtitle: 'Métricas simples, progreso visible',
  content: "Dejá de evaluar 'a ojo'. Herramientas prácticas para medir el rendimiento de tus jugadores, darles feedback constructivo y mostrarles con datos que están mejorando bajo tu mando.",
  bullets: []
}, {
  id: 'T6',
  title: 'Gestión del Grupo',
  subtitle: 'Construí un equipo que se banca solo',
  content: 'Estrategias reales para manejar egos, resolver conflictos en el vestuario, lidiar con faltazos crónicos y transformar un grupo de amigos en un equipo competitivo.',
  bullets: []
}];
export function TomosAccordion() {
  const [openId, setOpenId] = useState<string>('T1');
  return <section className="py-10 md:py-20 bg-[#0F172A] px-4" data-id="element-325">
      <div className="max-w-3xl mx-auto" data-id="element-326">
        <div className="text-center mb-8 md:mb-12" data-id="element-327">
          <h2 className="font-display text-3xl md:text-5xl text-white mb-2 md:mb-4 uppercase" data-id="element-328">
            CONTENIDO COMPLETO
          </h2>
          <p className="text-base md:text-xl text-gold font-bold uppercase tracking-wide mb-1 md:mb-2" data-id="element-329">
            LOS 6 TOMOS
          </p>
          <p className="text-sm md:text-lg text-gray-400 font-medium" data-id="element-330">
            Tu hoja de ruta para dirigir con autoridad y resultados
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-331">
          {tomos.map(tomo => {
          const isOpen = openId === tomo.id;
          return <div key={tomo.id} className={`border rounded-xl md:rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-gold/50 bg-gray-800 shadow-lg' : 'border-gray-700 bg-gray-900 hover:border-gold/30'}`} data-id="element-332">
                <button onClick={() => setOpenId(isOpen ? '' : tomo.id)} className="w-full text-left px-4 md:px-6 py-3 md:py-5 flex items-center gap-3 md:gap-4 focus:outline-none" aria-expanded={isOpen} data-id="element-333">
                  <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center shrink-0 font-display text-lg md:text-xl transition-colors ${isOpen ? 'bg-gold text-dark' : 'bg-gray-800 text-gray-500'}`} data-id="element-334">
                    {tomo.id}
                  </div>
                  <div className="flex-1" data-id="element-335">
                    <h3 className={`font-bold text-base md:text-xl leading-tight mb-0.5 md:mb-1 ${isOpen ? 'text-gold' : 'text-white'}`} data-id="element-336">
                      {tomo.title}
                    </h3>
                    <p className="text-gray-400 text-xs md:text-sm font-medium" data-id="element-337">
                      {tomo.subtitle}
                    </p>
                  </div>
                  <ChevronDown className={`text-gray-500 transition-transform duration-300 ${isOpen ? 'rotate-180 text-gold' : ''}`} size={20} data-id="element-338" />
                </button>

                <AnimatePresence data-id="element-339">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-340">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2 pl-[3.25rem] md:pl-[5.5rem]" data-id="element-341">
                        <p className="text-gray-300 text-sm md:text-base mb-3 md:mb-4 leading-relaxed" data-id="element-342">
                          {tomo.content}
                        </p>
                        {tomo.bullets.length > 0 && <ul className="space-y-1.5 md:space-y-2" data-id="element-343">
                            {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-xs md:text-sm font-medium text-white" data-id="element-344">
                                <span className="text-gold mt-0.5" data-id="element-345">✓</span>
                                {bullet}
                              </li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <p className="text-center text-xs md:text-sm text-gray-500 mt-4 md:mt-6 font-medium" data-id="element-346">
          Tocá cada tomo para ver lo que incluye 👆
        </p>
      </div>
    </section>;
}